import get from 'lodash/get'

export const isChannelManagerEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  return !!channelData.features.find(({ name, enabled }) => name === 'channelManagers' && enabled === true)

}
